import { css } from 'glamor';

const wrapper = css({
  position: 'fixed',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  top: 0,
  left: 0,
  width: '100%',
  height: '100vh',
  zIndex: 101,
  background: 'white',
});

export { wrapper };



// WEBPACK FOOTER //
// ./src/components/Loader/styles.js